/* eslint-disable prefer-destructuring */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

/**
 * useParseVideoUrl
 * 
 * @Author: Focci
 * @Date: 2024-03-21 14:43:15
 * @Last Modified by: Focci
 * @Last Modified time: 2024-03-21 14:43:15
 */

import { useCallback, useEffect, useState } from 'react'
import { getVideoObj } from './lib'

export default function useParseVideoUrl(videoUrl, autoplay) {
  const [result, setResult] = useState({})
  const [ready, setReady] = useState(false)

  const parse = useCallback((url) => {
    const tmp = getVideoObj(url, autoplay)
    setResult(tmp)
    setReady(true)
  }, [autoplay])

  useEffect(() => {
    videoUrl && parse(videoUrl) 
  }, [parse, videoUrl])

  return {
    parse,
    ready,
    result,
  }
}
